import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";
import sections from "../../../assets/data/mineralSections.json";
import mineralDatabase from "../../../assets/data/minerals.json"; //ok
import mineralGroupDatabase from "../../../assets/data/mineralGroups";

export default {
  namespaced: true,
  state() {
    return {
      // mineral: {},
      // minerals: mineralData.data,
      mineralDatabase: mineralDatabase.minerals, // Json Object with all minerals
      mineralGroupDatabase: mineralGroupDatabase,
      title: {
        //Titles current possible in english and portuguese
        en: "minerals",
        pt: "minerais",
      },
      currentTitle: "", //title in the user language
      filterError: false,
      filterOptions: [],
      filterResults: [],
      mineralNames: [], // Array of all mineral names in the user language
      hasMineral: true,
      noMatch: false,
      oneMineral: {},
      querySuggestions: [], // Array of mineral names that match the user input
      query: "",
      queryArray: [], // Array of query from section and filter
      allSelectOptions: sections.sections, // Object of section categories and subcategories
      selectOptions: [], // Array of options in currentLanguage and english
      results: [], // Array of objects or One object of mineral in the user language,
      rockMineral: {},
    };
  },
  mutations,
  actions,
  getters,
};
